import { FormControl, FormDescription, FormItem, FormMessage, useFormField } from "@ui/shad"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

import { TextInput } from "../inputs/text-input"

function maskDate(value: string) {
  const digits = value.replace(/\D/g, "").slice(0, 8)
  if (digits.length <= 2) return digits
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`
}

function displayDate(value: string) {
  const serverDateMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (serverDateMatch) {
    const [, year, month, day] = serverDateMatch
    return `${month}/${day}/${year}`
  }
  return maskDate(value)
}

interface TypedDateFieldProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof TextInput>, "value" | "onChange" | "onBlur" | "ref"> {
  id: string
  description?: string
  field: ControllerRenderProps<T, Path<T>>
}

export function TypedDateField<T extends FieldValues>({ field, id, description, ...props }: TypedDateFieldProps<T>) {
  const { error } = useFormField()
  const value = typeof field.value === "string" ? displayDate(field.value) : ""

  return (
    <FormItem>
      <FormControl>
        <TextInput
          {...props}
          {...field}
          id={id}
          value={value}
          onChange={(event) => field.onChange(maskDate(event.target.value))}
          error={!!error}
          inputMode="numeric"
          autoComplete="bday"
          maxLength={10}
        />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  )
}
